/* eslint-disable */
import $ from 'jquery';
import { DataLayer_cart } from './DataLayer_cart';
import { DataLayer_data_ready } from './DataLayer_data_ready';
import { Datalayer_search } from './DataLayer_search';
import { Datalayer_click } from './DataLayer_click';
import { DataLayer_events_form } from './DataLayer_events_form';
let page_path;
let trigger_datalayer_search = 'inactive';
let trigger_datalayer_cart = false;
let counter_cart;
let get_datalayer;
let user_email;

new DataLayer_events_form;
/**
 * Cart datalayer
 */
$( document )
  .on( 'ajaxComplete', function() { // wait the products in the shop load or some ajax in other pages
    /**
     *  add_to_cart datalayer
     */
    // add to cart button in the webshop
    $('.ajax_add_to_cart')
      .on('click', function () {
        trigger_datalayer_cart = true;
        const current_selector = $(this);
        const datalayer_cart_attr = {};
        datalayer_cart_attr.event = 'add_to_cart';
        datalayer_cart_attr.item_id = current_selector.attr('data-product_id');
        datalayer_cart_attr.item_quantity = 1;
        setTimeout(function() {
          // Check if the product was added to the cart and push a new datalayer
          if (( current_selector.hasClass( 'added' )) && ( trigger_datalayer_cart )) {
            new DataLayer_cart( datalayer_cart_attr );
            trigger_datalayer_cart = false;
          }
        },3000);
      });
    // Increase quantity in the cart
    $('.product-quantity > .number-input > .plus')
      .on('click', function () {
        const current_selector = $(this);
        const datalayer_cart_attr = {};
        datalayer_cart_attr.event = 'add_to_cart';
        datalayer_cart_attr.item_id = current_selector.parents().eq(3).attr('id');
        datalayer_cart_attr.item_quantity = 1;
        new DataLayer_cart( datalayer_cart_attr );
      });
    // Add Examentraining from the results page
    $('.search-results__item-table-button')
      .off('click').on('click', function () {
        trigger_datalayer_cart = true;
        counter_cart = $('.cart-contents-count').text();
        const current_selector = $(this);
        const datalayer_cart_attr = {};
        datalayer_cart_attr.origin = 'examentraining';
        datalayer_cart_attr.event = 'add_to_cart';
        datalayer_cart_attr.item_id = current_selector.parents().eq(2).attr('data-id');
        datalayer_cart_attr.item_quantity = 1;
        setTimeout(function() {
          trigger_datalayer_cart = true;
          // Check if the exam was added to the cart and push a new datalayer
          if (( current_selector.text() === 'Winkelwagen' ) && ( trigger_datalayer_cart )) {
            new DataLayer_cart( datalayer_cart_attr );
            trigger_datalayer_cart = false;
          }
        },3000);
      });
    // Add Licentie or Samenvatting in the cart
    $('.bundled_product > div > .addon_button')
      .on('click', function () {
        const current_selector = $(this);
        const datalayer_cart_attr = {};
        datalayer_cart_attr.event = 'add_to_cart';
        datalayer_cart_attr.item_id = current_selector.attr('data-child-id');
        datalayer_cart_attr.item_quantity = 1;
        // push a new datalayer
        new DataLayer_cart( datalayer_cart_attr );
      });
    /**
     *  remove_from_cart datalayer
     */
    // Decrease quantity in the cart
    $('.product-quantity > .number-input > .down')
      .on('click', function () {
        const current_selector = $(this);
        const datalayer_cart_attr = {};
        datalayer_cart_attr.event = 'remove_from_cart';
        datalayer_cart_attr.item_id = current_selector.parents().eq(3).attr('id');
        datalayer_cart_attr.item_quantity = 1;
        new DataLayer_cart( datalayer_cart_attr );
      });
    // Remove item in the cart
    $('.remove.cart-action')
      .off('click').on('click', function () { // off is a fix for double trigger of the event
        const current_selector = $(this);
        const datalayer_cart_attr = {};
        const quantity_selector = current_selector.parents('.product-card-right')
          .children('.product-quantity')
          .children('.number-input')
          .children('.quantity')
          .children('input[type=number]');
        if ( quantity_selector.length === 0 ){ // If the product is examentraining
          // check if there are selected bundle products
          const bundled_products_selector = current_selector.parents().eq(1).nextAll().first();
          bundled_products_selector.find('.addon_remove_button').each(function(){
            // create and push a new datalayer for each bundle product that will be also removed from the cart
            const datalayer_cart_sub_attr = {};
            datalayer_cart_sub_attr.event = 'remove_from_cart';
            datalayer_cart_sub_attr.item_id = $(this).attr('data-child-id');
            datalayer_cart_sub_attr.item_quantity = 1;
            new DataLayer_cart( datalayer_cart_sub_attr );
          });
          datalayer_cart_attr.origin = 'examentraining';
          datalayer_cart_attr.item_id = current_selector.attr('data-product_sku');
          datalayer_cart_attr.item_quantity = 1;
        } else { // if the product is not examentraining
          datalayer_cart_attr.item_id = current_selector.attr('data-product_id');
          datalayer_cart_attr.item_quantity = quantity_selector.val();
        }
        datalayer_cart_attr.event = 'remove_from_cart';
        new DataLayer_cart( datalayer_cart_attr );
      });
    // Remove Licentie or Samenvatting in the cart
    $('.bundled_product > div > .addon_remove_button')
      .on('click', function () {
        const current_selector = $(this);
        const datalayer_cart_attr = {};
        datalayer_cart_attr.event = 'remove_from_cart';
        datalayer_cart_attr.item_id = current_selector.attr('data-child-id');
        datalayer_cart_attr.item_quantity = 1;
        new DataLayer_cart( datalayer_cart_attr );
      });

  });

/**
 * Payment datalayers
 */
// Create a new datalayer when the user click the button to go to payment section
$('.payment_button')
  .on('click', function () {
    setTimeout(function() { // wait the response of the form validations
      // Check if the payment tab is visible
      if ($('.checkout_payment_wrapper').is(':visible')) { // validation was successfully done
        // Prepare the data for the data_ready datalayer
        const datalayer_data_ready_attr = {};
        datalayer_data_ready_attr.page_type = 'detail';
        datalayer_data_ready_attr.content_group = 'webshop';
        datalayer_data_ready_attr.content_type = 'payment';
        datalayer_data_ready_attr.content_variant = 'none';
        // Push a new datalayer when the user navigates to payment
        new DataLayer_data_ready( datalayer_data_ready_attr );
        // Prepare the data for the add_shipping_info datalayer
        const datalayer_cart_attr = {};
        get_datalayer = dataLayer.find(function(obj){return obj.event==="begin_checkout"});
        datalayer_cart_attr.origin = 'payment';
        datalayer_cart_attr.event = 'add_shipping_info';
        datalayer_cart_attr.items_object = get_datalayer.ecommerce.items;
        datalayer_cart_attr.cart_total_value = get_datalayer.ecommerce.value;
        user_email = $('#billing_email').val();
        window.localStorage.setItem('user_email_key', user_email); // Store the user email in a session variable
        new DataLayer_cart( datalayer_cart_attr );
      }
    },500);
  });

// Create a new datalayer when the user click the button to pay
$('#place_order')
  .on('click', function () {
    // Prepare the data for the add_payment_info datalayer
    const datalayer_cart_attr = {};
    get_datalayer = dataLayer.find(function(obj){return obj.event==="begin_checkout"});
    datalayer_cart_attr.origin = 'payment';
    datalayer_cart_attr.event = 'add_payment_info';
    datalayer_cart_attr.items_object = get_datalayer.ecommerce.items;
    window.localStorage.setItem('items_object_key', JSON.stringify(datalayer_cart_attr.items_object));
    datalayer_cart_attr.cart_total_value = get_datalayer.ecommerce.value;
    window.localStorage.setItem('cart_total_value_key', datalayer_cart_attr.cart_total_value);
    new DataLayer_cart( datalayer_cart_attr );
  });
/**
 * Search datalayer
 */
// Prepare the trigger and origin page for the results page
$('.front-search__form-submit')
  .on('click', function () {
    page_path = window.location.href; // Get the current url
    window.localStorage.setItem('page_path_key', page_path); // Store the current url in a session variable
    trigger_datalayer_search = 'active';
    window.localStorage.setItem('trigger_datalayer_search_key', trigger_datalayer_search); // Store the trigger for the datalayer in a session variable
    // Only for search in the bijles and HWB pages that show results without refresh
    setTimeout(function() {
      if (page_path !== window.location.href) {
        const datalayer_search_attr = {};
        datalayer_search_attr.origin_page_path = page_path;
        datalayer_search_attr.page_path = window.location.href;
        // Push a new datalayer when the page is a search result
        if ( trigger_datalayer_search === 'active' ) {
          trigger_datalayer_search = 'inactive';
          new Datalayer_search( datalayer_search_attr );
        }
        window.localStorage.setItem('trigger_datalayer_search_key', trigger_datalayer_search); // Store the 'inactive' value for the trigger in a session variable
      }
    },2000);
  });

$(window)
  .on('load',function() {
    page_path = window.location.href; // Get the current url
    /**
     * Search datalayer
     */
    const datalayer_search_attr = {};
    datalayer_search_attr.page_path = page_path;
    datalayer_search_attr.origin_page_path = window.localStorage.getItem('page_path_key'); // Get the previous url from a session variable
    trigger_datalayer_search = window.localStorage.getItem('trigger_datalayer_search_key');
    // Push a new datalayer when the page is a search result
    if ( trigger_datalayer_search === 'active' ) {
      trigger_datalayer_search = 'inactive';
      new Datalayer_search( datalayer_search_attr );
    }
    window.localStorage.setItem('trigger_datalayer_search_key', trigger_datalayer_search); // Store the 'inactive' value for the trigger in a session variable
    /**
     * Purchase datalayer
     */
    // Create a new datalayer when payment was accepted and returns to the 'thank you' page
    if ( page_path.indexOf('/afrekenen/order-received/') >= 0 ) {
      // Prepare the data for the purchase datalayer
      const datalayer_cart_attr = {};
      datalayer_cart_attr.origin = 'payment';
      datalayer_cart_attr.event = 'purchase';
      datalayer_cart_attr.items_object = JSON.parse(window.localStorage.getItem('items_object_key'));
      const url_split = page_path.split('/');
      datalayer_cart_attr.transaction_id = url_split[5];
      datalayer_cart_attr.cart_total_value = JSON.parse(window.localStorage.getItem('cart_total_value_key'));
      datalayer_cart_attr.user_email = window.localStorage.getItem('user_email_key');
      new DataLayer_cart( datalayer_cart_attr );
    }
    /**
     * Advice popup datalayers
     */
    $('.contact_options_whatsapp').on('click', function(){
      const datalayer_click_attr = {};
      datalayer_click_attr.event = 'advice_popup';
      datalayer_click_attr.target = 'whatsapp';
      datalayer_click_attr.page_path = page_path;
      new Datalayer_click( datalayer_click_attr );
    });
    $('.contact_options_phone').on('click', function(){
      const datalayer_click_attr = {};
      datalayer_click_attr.event = 'advice_popup';
      datalayer_click_attr.target = 'phone';
      datalayer_click_attr.page_path = page_path;
      new Datalayer_click( datalayer_click_attr );
    });
  });
